module.exports = __webpack_public_path__ + "static/media/third.985cbc69.jpg";